import React from 'react';
import styled from 'styled-components';

import Container from '../layout/Container';
import Button from '../components/Button';
import PaidContent from '../components/PaidContent';

const PositionedButton = styled(Button)`
  && {
    margin-bottom: ${({ theme }) => theme.sizes.lvl6};
  }
`;

const Wrapper = styled(Container)`
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;

  a {
    color: black;
    text-decoration: none;
  }

  ${({ theme }) => theme.breakpoint('phoneLarge')`
    padding: ${({ theme }) => theme.sizes.lvl5}
      ${({ theme }) => theme.sizes.lvl3} ${({ theme }) => theme.sizes.lvl2} ${({
    theme,
  }) => theme.sizes.lvl3};
  `}
  ${({ theme }) => theme.breakpoint('tabletPortrait')`
    padding: ${({ theme }) => theme.sizes.lvl7}
      ${({ theme }) => theme.sizes.lvl5} ${({ theme }) => theme.sizes.lvl3} ${({
    theme,
  }) => theme.sizes.lvl5};
  `}
  ${({ theme }) => theme.breakpoint('desktop')`
    padding: ${({ theme }) => theme.sizes.lvl10}
      ${({ theme }) => theme.sizes.lvl8} ${({ theme }) => theme.sizes.lvl4} ${({
    theme,
  }) => theme.sizes.lvl8};
  `}
`;

const ListContainer = styled.ul`
  text-align: left;
  margin-top: ${({ theme }) => theme.sizes.lvl2};
  li {
    margin-bottom: ${({ theme }) => theme.sizes.lvl2};
    font-size: ${({ theme }) => theme.sizes.lvl2};
    font-size: ${({ theme }) => theme.sizes.lvl2};
    a {
      text-decoration: none;
      font-weight: bold;
      color: ${({ theme }) => theme.colours.primary};
    }
  }
`;

const DownArrow = styled.span`
  color: ${({ theme }) => theme.colours.primary};
  font-size: ${({ theme }) => theme.sizes.lvl5};
  ${({ theme }) => theme.breakpoint('tabletPortrait')`
    display: none;
  `}
`;

const Copy = styled.p`
  a {
    color: ${({ theme }) => theme.colours.primary};
  }
`;

const ThankYouIntroFeaturedGiftSection = ({ context, giftDownloadLink }) => {
  const { conferenceDateString, title } = context;

  return (
    <Wrapper>
      <h1 className="h3">
        Thank you for registering for your <br />
        <span>Fatigue: 12 Secrets to Recovery eBook</span> <br />
      </h1>
      <a href={giftDownloadLink} target="_BLANK" title="Download eBook">
        <PositionedButton>Download eBook</PositionedButton>
      </a>
      <Copy>
        Your registration also includes a FREE PLACE at the <br />
        <strong className="strong">{title}</strong> which runs{' '}
        <strong className="strong">{conferenceDateString}</strong>
      </Copy>
      <Copy>
        The conference features over 45 interviews with fatigue experts
        exploring the role of the gut in fatigue, how toxins and chemicals can
        zap energy, the role of the maladaptive stress response and trauma in
        fatigue, and much, much more!
      </Copy>
      <ListContainer>
        <li>
          <a title="Bookmark the agenda page" href="#stepBookmark">
            Bookmark
          </a>{' '}
          the Day Agenda Page
        </li>

        <li>
          <a title="Access free gifts" href="#stepGifts">
            Access
          </a>{' '}
          your free gifts
        </li>
        <PaidContent
          notPaid={<li>Take advantage of sale prices to keep these talks!</li>}
        >
          <></>
        </PaidContent>
      </ListContainer>
      <Copy>
        You can find out more about the speakers by heading to the agenda page
        below.
      </Copy>

      <DownArrow className="material-icons header-arrow">
        keyboard_arrow_down
      </DownArrow>
    </Wrapper>
  );
};

export default ThankYouIntroFeaturedGiftSection;
